<template>
  <div class="app-shell">
    <MeshBackdrop />
    <CursorSpotlight />

    <header class="toolbar">
      <ThemeToggle />
      <div class="language-switch">
        <button
          type="button"
          class="lang-btn glass-button"
          :class="{ active: currentLocale === 'en' }"
          @click="changeLocale('en')"
        >
          EN
        </button>
        <button
          type="button"
          class="lang-btn glass-button"
          :class="{ active: currentLocale === 'de' }"
          @click="changeLocale('de')"
        >
          DE
        </button>
      </div>
    </header>

    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import i18n from "./i18n";
import MeshBackdrop from "@/components/MeshBackdrop.vue";
import CursorSpotlight from "@/components/CursorSpotlight.vue";
import ThemeToggle from "@/components/ThemeToggle.vue";

export default defineComponent({
  name: "App",
  components: {
    MeshBackdrop,
    CursorSpotlight,
    ThemeToggle,
  },
  setup() {
    const currentLocale = computed(() => i18n.global.locale.value);

    function changeLocale(locale: string): void {
      i18n.global.locale.value = locale;
    }

    return { currentLocale, changeLocale };
  },
});
</script>

<style lang="scss" scoped>
.app-shell {
  position: relative;
  min-height: 100vh;
}

.toolbar {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.language-switch {
  display: flex;
  gap: 0.25rem;
}

.lang-btn {
  padding: 0.35rem 0.65rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--muted-foreground);
  border: 1px solid var(--border);
  background: var(--card);

  &.active {
    color: var(--foreground);
    box-shadow: var(--shadow-soft);
  }
}
</style>

<style lang="scss" global>
@use "global.scss" as *;

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: "Geist Sans", ui-sans-serif, system-ui, sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: var(--foreground);
  background: var(--background);
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

a {
  color: inherit;
  text-decoration: none;
}

h2 {
  font-size: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  text-align: center;
  margin-bottom: 2.5rem;
  color: var(--foreground);
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
}
</style>
